

export enum KalturaCaptionSource {
    unknown = '0',
	zoom = '1'
}